import { Card, Typography, Space } from "antd";
import Setting from "Components/Report/OnDemand/charts/shared/Setting";
import { AccountValues, DeviceValues } from "Components/Report/OnDemand/Filter";
import React, { ReactNode } from "react";

type CardProps = React.ComponentProps<typeof Card>;

interface ChartCardProps extends CardProps {
  children: React.ReactNode;
  isFetching: boolean;
  param: AccountValues | DeviceValues;
  title: any;
}

const { Text } = Typography;

const ChartCard = ({ children, title, param, isFetching }: ChartCardProps) => {
  const IsChartNode = !param.includes("table"); //Need a better solution to recognize the chart type

  return (
    <Card
      bodyStyle={{ height: "415px" }}
      bordered={false}
      title={title}
      loading={isFetching}
      // extra={IsChartNode ? <Setting param={param} id={title?._owner?.pendingProps?.id} /> : null} // FIXME: account-level setting to be fixed
    >
      {children}
    </Card>
  );
};

export default ChartCard;

export const ChartTitle = (type: string, label: string, id: string, name?: string | undefined): string | ReactNode => {
  if (type === "Account") {
    return label;
  } else {
    return (
      <Space size={"small"}>
        <Text>{label}</Text>
        <Text type="secondary" style={{ fontSize: "0.8rem" }}>
          {id} {name}
        </Text>
      </Space>
    );
  }
};
